<template>
  <div>
    <div class="applybt" @click="openApply">
      {{ inputName }}
    </div>
    <!-- 申请试用 -->
    <el-dialog
      :title="inputName"
      :visible.sync="dialogVisible"
      width="600px"
      @close="close"
    >
      <el-form
        :model="agriculturalFeedbackForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="姓名" prop="userName">
          <el-input
            v-model="agriculturalFeedbackForm.userName"
            placeholder="请输入您的姓名或称呼"
            @input="change"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系方式" prop="contact">
          <el-input
            v-model="agriculturalFeedbackForm.contact"
            placeholder="请输入您的联系方式"
            @input="change"
          ></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="content">
          <el-input
            v-model="agriculturalFeedbackForm.content"
            placeholder="请输入备注信息"
            class="input"
            @input="change"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: ['inputName', 'type'],
  data() {
    return {
      dialogVisible: this.data,
      rules: {
        userName: [
          { required: true, message: '请输入您的姓名或称呼', trigger: 'blur' }
        ],
        contact: [
          { required: true, message: '请输入您的联系方式', trigger: 'blur' }
        ]
      },
      agriculturalFeedbackForm: {
        userName: '',
        contact: '',
        content: '', // 备注
        source: this.type // 反馈来源 0-消费者C端 2-官网智慧农贸 3-官网 AI识别
      }
    }
  },
  watch: {},
  created() {},
  computed: {
    // type
    normalizedSize: function() {
      return this.type.trim().toLowerCase()
    }
  },
  methods: {
    openApply() {
      this.dialogVisible = true
    },
    close() {
      this.dialogVisible = false
      // 清空列表
      this.agriculturalFeedbackForm.userName = ''
      this.agriculturalFeedbackForm.content = ''
      this.agriculturalFeedbackForm.contact = ''
    },
    // 提交申请
    async submit() {
      // 验证表单是否合理
      this.$refs.ruleForm.validate(async valid => {
        if (!valid) return
        // 验证通过，进行下一步操作
        // type转为整型
        this.agriculturalFeedbackForm.source = parseInt(
          this.agriculturalFeedbackForm.source
        )
        const { data: res } = await this.$http.post(
          '/api/v1/user/agriculturalFeedback',
          this.agriculturalFeedbackForm
        )
        // console.log(response)
        if (res.code !== 0) {
          return this.$message.error(res.message)
        }
        this.$message.success('提交成功')
        this.dialogVisible = false
      })
    },
    change() {
      this.$forceUpdate()
    }
  }
}
</script>

<style lang="less" scoped>
.applybt {
  margin: 0 auto;
  border: 1px solid #fff;
  text-align: center;
  height: 80px;
  line-height: 80px;
  width: 322px;
  border-radius: 40px;
  font-weight: 500;
  letter-spacing: 5px;
  cursor: default;
  font-size: 28px;
  cursor: pointer;
}
.applybt:hover {
  font-size: 30px;
}
.el-dialog {
  font-size: 32px;
}
</style>
